// Used by Vue Meta, the build-time HTML writer and the server-route generator.
const pages = require('./pages.json');
const origin = 'https://www.ari.company';
const aliases = {
  '/ari-ai': '/odin',
  '/gsc-snapshot': '/ari-pulse',
  '/android/apple-hunter/app.html': '/android/apple-hunter',
  '/android/apple-hunter/privacy-apple-hunter.html': '/android/apple-hunter/privacy-apple-hunter'
};
const normalize = value => {
  const path = (value || '/').split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase() || '/';
  return aliases[path] || path;
};
function availablePages(review = false) {
  return Object.fromEntries(Object.entries(pages).flatMap(([route, page]) => {
    if (page.status !== 'draft' || review) return [[route, page]];
    return page.published ? [[route, { ...page, ...page.published }]] : [];
  }));
}
function metadataFor(path, review = false, localMeta = {}) {
  let route = normalize(path);
  let page = availablePages(review)[route];
  if (!page) {
    route = '/404';
    page = { ...pages[route], title: localMeta.title || pages[route].title, description: localMeta.desc || pages[route].description };
  }
  const social = page.social || {};
  const meta = [
    {vmid:'description', name:'description', content:page.description},
    ...(page.status !== 'public' ? [{vmid:'robots', name:'robots', content:'noindex, nofollow'}] : []),
    {vmid:'og:url', property:'og:url', content:origin + route},
    {vmid:'og:title', property:'og:title', content:social.title || page.title},
    {vmid:'og:description', property:'og:description', content:social.description || page.description},
    {vmid:'og:type', property:'og:type', content:'website'},
    ...['image', 'width', 'height', 'alt'].filter(key => social[key]).map(key => ({
      vmid: key === 'image' ? 'og:image' : 'og:image:' + key,
      property: key === 'image' ? 'og:image' : 'og:image:' + key,
      content: key === 'image' ? origin + social[key] : social[key]
    })),
    ...(social.card ? [{vmid:'twitter:card', name:'twitter:card', content:social.card}] : [])
  ];
  return {title:page.title, link:[{vmid:'canonical', rel:'canonical', href:origin + route}], meta};
}
module.exports = {pages, origin, aliases, normalize, availablePages, metadataFor};
